import React from 'react'

export default function NotFoundPage () {
  return (
    <div className="NotFoundPage">
      <h1 className="u-heading">Хм, кажется у нас тут проблемка </h1>
      <p>Такой странички у нас нет</p>
    </div>
  )
}
